import axios from "axios";
import qs from "query-string";
import * as Sentry from "@sentry/react";

import { getAuthToken, removeAuthToken } from "../../auth/utils/helpers";
import { getSubdomain } from "./helpers";
import { authRoutesConstants } from "modules/auth/routes/routesConstants";

export const httpCreator = (baseURL: string) => {
  const axiosInstance = axios.create({ baseURL });

  // Default params serializer
  axiosInstance.defaults.paramsSerializer = providedParams =>
    qs.stringify(providedParams, {
      arrayFormat: "bracket",
      skipEmptyString: true,
      skipNull: true
    });

  // Request interceptors
  axiosInstance.interceptors.request.use(config => {
    const token = getAuthToken();

    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = token;
    }

    // add subdomain param to all requests
    config.params = config.params || {};
    config.params.subdomain = getSubdomain();

    return config;
  });

  // Response interceptors
  axiosInstance.interceptors.response.use(
    response => {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      return response;
    },
    error => {
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      if (error.response) {
        if (error.response.status === 401) {
          removeAuthToken();
          window.location.href = authRoutesConstants.login.href(
            window.location.pathname + window.location.search
          );
        }

        if (error.response.status >= 500) {
          Sentry.captureException(error);
        }
      }
      return Promise.reject(error);
    }
  );

  return axiosInstance;
};
